import React, { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import OtherConfigCargo from './Modal/OtherCargoConfig/OtherConfigCargo'
import OtherCargoCreditLimit from './Modal/OtherCargoConfig/OtherCargoCreditLimit'
import { findObjctByValueFromArrayOfObject, focusElemnt } from '../../../common/helper'
import CancelLRPenaltyOnFreight from './Modal/OtherCargoConfig/CancelLRPenaltyOnFreight'
import OtherConfigCommission from './Modal/OtherCargoConfig/OtherConfigCommission'
import MinFreightPerParcel from './Modal/OtherCargoConfig/MinFreightPerParcel'
import OtherConfigGST from './Modal/OtherCargoConfig/OtherConfigGST'
import OtherConfigPrint from './Modal/OtherCargoConfig/OtherConfigPrint'
import DefaultRateIncrease from './Modal/OtherCargoConfig/DefaultRateIncrease'
import { getBranchData, getGSTNValidation, getBranchMaster, updateOtherCargoBranchCofigData, getBranchDetailsInfo } from '../../../../store/branchAndUserMaster/BUMAction'
import { AmtAndPerOpt, bkngPrintOpt, bookingTypeOpt, BrnchOtherCargoConfigObject, CreditLimitTypeOpt, GstModalObject } from './BrnchMasterConstant'
import { connect } from 'react-redux'
import * as mdt from '../../../common/modaltypes'
import GSTStatusModal from './Modal/GSTStatusModal'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'
import { getPrintFormatList, updateAlertError } from '../../../../store/common/common_action'
import OTPModal from '../UserRollRights/OTPModal'
import ConfirmModal from './Modal/ConfirmModal'
import BookingDeliveryOTP from './Modal/OtherCargoConfig/BookingDeliveryOTP'
import { luggageSendOTP } from '../../../common/jotaiState/commonStateAtoms'

const BranchCargoOtherConfig = (props) => {
    const { data: { common, branchAndUserMasterReducer }, getBranchData, getGSTNValidation, getBranchDetailsInfo, setSelectedTab, tabData, confModal, setConfModal, updateModal, getBranchMaster, branchBusValue, setBranchBusValue,
        isDisableBtn, setIsDisableBtn, resetAllValueBrnhMaster, setTabData, setSelCargoAccBrnhOpt, updateOtherCargoBranchCofigData, updateAlertError,loginData } = props
    const { ModalHeaderDropDownData } = branchAndUserMasterReducer
    const { waybillFormats = [] } = common
    const { getPrintFormatList } = props
    const [resetFlag, setResetFlag] = useState(false)
    const [selectedOtherWayBill, setSelectedOtherWayBillFormat] = useState()
    const [selectedDeliveryWayBill, setSelectedDeliveryWaybill] = useState('')
    const [bkngPrnitCopy, setBkngPrnitCopy] = useState([])
    const [delPrnitCopy, setDelPrnitCopy] = useState([])
    const [gstStatusModalProps, setGstStatusModalProps] = useState({})
    const [gstStatusModal, setGstStatusModal] = useState(false)
    const [showBottom, setShowBottom] = useState(false)
    const [headerData, setHeaderData] = useState([])
    const [successAndError, setSuccessAndError] = useState({
        isOpen: false,
        id: 0,
        title: '',
        focusId: '',
        openNextTab: false
    })
    const [OtpModal, setOtpModal] = useState(false)
    const [OTP, setOTP] = useState("")
    const [isOpen, setIsOpen] = useState({ open: false, message: "" })
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    const { BranchList, brnhOtherCargoGST,
        setBrnhOtherCargoGST,
        brnhOtherCargoValue,
        setBrnchOtherCargoValue,
        selOtherCargoAccBrnhOpt,
        setSelOtherCargoAccBrnhOpt } = props
    const [searchParams, setSearchParams] = useSearchParams()
    const [masterNumber, setMasterNumber] = useState(Number(searchParams.get('tab')) || "")
    const [allTabs, setAllTabs] = useState([])

    const tabsList = [{ JobID: 11, name: "Cargo Detail" }, { JobID: 21, name: "Credit Limit" }, { JobID: 31, name: "Cancel LR Penalty" }, { JobID: 50, name: "Commission" },
    { JobID: 51, name: "Freight Per Parcel" }, { JobID: 61, name: "GST  Config." }, { JobID: 71, name: "Freight Increase by" }, { JobID: 81, name: "Print Config." },{ JobID: 90, name: "BOOKING-DELIVERY OTP" }]
    useEffect(() => {
        const allGSPages = sessionStorage.getItem('token1');
        const allGSPagesActive = JSON.parse(allGSPages);

        if (masterNumber === '') {
            const newData = tabsList.filter((item) => item.JobID !== 4 ? findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', "IsActive") === 1 ? item : null : item)
            goToTabs(newData?.[0]?.JobID)
        }

        if (allGSPagesActive?.length > 0) {
            setAllTabs(allGSPagesActive)
        } else {
            setAllTabs([])
        }
    }, [searchParams])
    useEffect(() => {
        let newData = [{
            CompanyID: loginData?.intCompanyID,
            CompanyName: loginData?.strCompanyName,
            State: ModalHeaderDropDownData?.selState?.StateName,
            City: ModalHeaderDropDownData?.selCity?.CityName,
            Branch: ModalHeaderDropDownData?.branchCode
        }]
        setHeaderData(newData)
    }, [ModalHeaderDropDownData])

    useEffect(() => {
        if (waybillFormats.length && brnhOtherCargoValue.CargoStandardTicketFormatID) {
            setSelectedOtherWayBillFormat(findObjctByValueFromArrayOfObject(waybillFormats, brnhOtherCargoValue.CargoStandardTicketFormatID, 'FormatID')[0])
        }
        if (waybillFormats.length && brnhOtherCargoValue.DeliveryPrintFormatID) {
            setSelectedDeliveryWaybill(findObjctByValueFromArrayOfObject(waybillFormats, brnhOtherCargoValue.DeliveryPrintFormatID, 'FormatID')[0])
        }
    }, [brnhOtherCargoValue])
    useEffect(() => {
        if (Array.isArray(waybillFormats) && waybillFormats.length) {
            setSelectedOtherWayBillFormat(waybillFormats[0])
            setSelectedDeliveryWaybill(waybillFormats[0])
        }
    }, [waybillFormats])


    const params = {}
    for (let entry of searchParams.entries()) {
        params[entry[0]] = entry[1]
    }
    const goToTabs = (lrTab) => {
        params.tab = lrTab
        setSearchParams(params)
        setMasterNumber(lrTab)
        setShowBottom(false)
    }

    useEffect(() => {
      focusElemnt('companyM')
    }, [])
    useEffect(() => {
      if (loginData.intCompanyID) {
        getPrintFormatList(loginData.intCompanyID)
      }
    }, [loginData.intCompanyID])
    const saveBrnchCargoConfig = (isCofModal = false) => {
        if (brnhOtherCargoGST?.errorModal) {
            setSuccessAndError({
                isOpen: true,
                id: 0,
                title: 'Enter Valid GST Number',
                focusId: 'cargo_book_gst',
                openNextTab: false
            })
        } else {
            let body = {
                CompanyID: loginData.intCompanyID,
                BranchID: ModalHeaderDropDownData?.selBranch?.BranchID,
                AccountingBranchID: brnhOtherCargoValue?.cargoAccBrnh?.BranchID || 0,
                CargoFranchisee: brnhOtherCargoValue?.CargoFranchiseeName || '',
                CargoGSTN: brnhOtherCargoValue?.CargoGSTNO || '',
                MaxLRNO: brnhOtherCargoValue?.MaxLRNo || 0,
                CargoIsCreditLimit: brnhOtherCargoValue?.IsCargoCreditLimit || 0,
                CargoCreditLimit: brnhOtherCargoValue?.CargoCreditLimit || 0,
                CreditLimitPayType: brnhOtherCargoValue?.CreditLimitPayType?.id,
                PaidCreditLimit: Number(brnhOtherCargoValue?.PaidCreditLimit) || 0,
                TopayCreditLimit: Number(brnhOtherCargoValue?.TopayCreditLimit) || 0,
                IsLRPenaltyOnFreight: brnhOtherCargoValue?.IsLRPenaltyOnFreight || 0,
                IsDocChgAsLrPenalty: brnhOtherCargoValue?.IsDocChgAsLrPenalty || 0,
                PenaltyAfterMinutes: brnhOtherCargoValue?.PenaltyAfterMinutes || 0,
                LRPenaltyOnFreightPer: Number(brnhOtherCargoValue?.LRPenaltyOnFreightPer) || 0,
                LRPenaltyOnFreightAmt: Number(brnhOtherCargoValue?.LRPenaltyOnFreightAmt) || 0,
                BusCommPct: brnhOtherCargoValue?.BusCommPct || 0,
                CargoCommPct: brnhOtherCargoValue?.CargoCommPct || 0,
                BookingPTLComm: Number(brnhOtherCargoValue?.BookingPTLComm) || 0,  
                DeliveryPTLComm: Number(brnhOtherCargoValue?.DeliveryPTLComm) || 0,
                BookingFTLComm: brnhOtherCargoValue?.BookingFTLComm || 0,  // Assuming you want to pull this from tableDataObj
                DeliveryFTLComm: brnhOtherCargoValue?.DeliveryFTLComm || 0,  // Same assumption as above
                IsMinFreightPerParcel: brnhOtherCargoValue?.IsMinFreightPerParcel || 0,
                MinFreightPerParcel: Number(brnhOtherCargoValue?.MinFreightPerParcel) || 0,
                IsMaxFreightPerParcel: brnhOtherCargoValue?.IsMaxFreightPerParcel || 0,
                MaxFreightPerParcel: Number(brnhOtherCargoValue?.MaxFreightPerParcel) || 0,
                CargoGSTPct: brnhOtherCargoValue?.CargoTaxPct || 0,
                HasCargoCGST: brnhOtherCargoValue?.CargoHasCGST || 0,
                HasCargoSGST: brnhOtherCargoValue?.CargoHasSGST || 0,
                HasCargoIGST: brnhOtherCargoValue?.CargoHasIGST || 0,
                IsDefaultRateIncreasedBy: brnhOtherCargoValue?.IsDefaultRateIncreasedBy || 0,
                DefaultRateIncreasePer: brnhOtherCargoValue?.DefaultRateIncreasePer || 0,
                DefaultRateIncreaseAmt: brnhOtherCargoValue?.DefaultRateIncreaseAmt || 0,
                CargoHasBilltyLaserPrint: brnhOtherCargoValue?.CargoHasBilltyLaserPrint || 0,
                CargoStandardTicketFormatID: brnhOtherCargoValue?.CargoHasBilltyLaserPrint ? selectedOtherWayBill?.FormatID : 0,
                DeliveryPrintFormatID: brnhOtherCargoValue?.CargoHasBilltyLaserPrint ? selectedDeliveryWayBill?.FormatID : 0,  // Not in `body`, you may want to adjust this
                IsBookingCustomerCopy: brnhOtherCargoValue?.IsBookingCustomerCopy || 0,  // Not in `body`, you may want to adjust this
                IsBookingBranchCopy: brnhOtherCargoValue?.IsBookingBranchCopy || 0,  // Not in `body`, you may want to adjust this
                IsBookingDriverCopy: brnhOtherCargoValue?.IsBookingDriverCopy || 0,  // Not in `body`, you may want to adjust this
                IsDeliveryCustomerCopy: brnhOtherCargoValue?.IsDeliveryCustomerCopy || 0,  // Not in `body`, you may want to adjust this
                IsDeliveryBranchCopy: brnhOtherCargoValue?.IsDeliveryBranchCopy || 0,  // Not in `body`, you may want to adjust this
                IsDeliveryDriverCopy: brnhOtherCargoValue?.IsDeliveryDriverCopy || 0,  // Not in `body`, you may want to adjust this
                UserID: loginData.intUserID,
                //Booking and Delivery OTP
                HasReceiverOtpBooking: brnhOtherCargoValue?.HasRecOtpBkg || 0,
                HasReceiverOtpDelivery: brnhOtherCargoValue?.HasRecOtpDel || 0,
                IsRecipientDeliveryOTP: brnhOtherCargoValue?.IsRecipientDeliveryOTP || 0,
                RecBkgOtpAll: brnhOtherCargoValue?.RecBkgOtpAll || 0,
                RecBkgOtpOnAcc: brnhOtherCargoValue?.RecBkgOtpOnAcc || 0,
                RecDelOtpAll: brnhOtherCargoValue?.RecDelOtpAll || 0,
                RecDelOtpAll: brnhOtherCargoValue.RecDelOtpAll,
                RecDelOtpOnAcc: brnhOtherCargoValue.RecDelOtpOnAcc,
            };
            updateOtherCargoBranchCofigData(body).then((res) => {
                if (res.status === 'Success') {
                    setIsOpen({ ...isOpen, open: true, message: "Saved Successfully!" })
                    getBranchMaster(loginData.intCompanyID)
                    setSuccessAndError({
                        isOpen: true,
                        id: 1,
                        title: `Branch Cargo Other Config\nSaved Successfully!`,
                        focusId: 'saveBtn',
                        openNextTab: isCofModal
                    })
                    setConfModal((prev) => ({
                        ...prev,
                        branchOtherConfig: false
                    }))
                } else {
                    setSuccessAndError({
                        isOpen: true,
                        id: 0,
                        title: res?.Message,
                        focusId: 'saveBtn',
                        openNextTab: false
                    })
                }
            })
        }
    }
    const showGstStatusModal = (value, ismodalOpen = false) => {
        const body = {
            GSTN: value
        }
        getGSTNValidation(body).then((res) => {
            if (res.status === 'True') {
                let data = {
                    updateModal: setGstStatusModal,
                    headText: "GSTIN Status",
                    gstData: { ...res.Data[0], GSTIN: value }
                }
                setGstStatusModalProps(data)
                setBrnhOtherCargoGST({ ...res.Data[0], GSTIN: value, errorModal: false })
                if (ismodalOpen) {
                    setGstStatusModal(true)
                }
            } else {
                setBrnhOtherCargoGST({ ...GstModalObject, GSTIN: value, errorModal: true })
                if (ismodalOpen) {
                    setSuccessAndError({
                        isOpen: true,
                        id: 0,
                        title: 'Enter Valid GST Number',
                        focusId: 'bus_book_gst',
                        openNextTab: false
                    })
                }
            }
        })

    }

    const getBranchCargoData = () => {
        setConfModal((prev) => ({
            ...prev,
            branchOtherConfig: false
        }))
        const bodyBranch = {
            intUserID: 0,
            intCompanyID: loginData.intCompanyID,
            intBranchID: ModalHeaderDropDownData?.selBranch?.BranchID,
            strBranchName: "",
            strBranchCode: "",
            intStateID: 0,
            intCityID: 0,
            intIsActive: -1
        }
        getBranchData(bodyBranch).then((res) => {
            if (res.status === 'Success') {
                let BranchListOpt = BranchList.filter((val) => val?.IsActive === 1)
                setSelOtherCargoAccBrnhOpt(BranchListOpt)
                let selectedBranch = res.Data.Table
                if (selectedBranch.length > 0) {
                    if (selectedBranch[0]?.CargoGSTNO) {
                        showGstStatusModal(selectedBranch[0]?.CargoGSTNO)
                    }
                    let newArr = []
                    let newArr1 = []
                    if (selectedBranch?.[0]?.CargoStandardTicketFormatID === 1||selectedBranch?.[0]?.CargoStandardTicketFormatID === 7) {
                        if (selectedBranch?.[0]?.IsBookingCustomerCopy === 1) {
                            newArr.push(bkngPrintOpt[0])
                        }
                        if (selectedBranch?.[0]?.IsBookingBranchCopy === 1) {
                            newArr.push(bkngPrintOpt[1])
                        }
                        if (selectedBranch?.[0]?.IsBookingDriverCopy === 1) {
                            newArr.push(bkngPrintOpt[2])
                        }
                    }
                    if (selectedBranch?.[0]?.DeliveryPrintFormatID === 1) {
                        if (selectedBranch?.[0]?.IsDeliveryCustomerCopy === 1) {
                            newArr1.push(bkngPrintOpt[0])
                        }
                        if (selectedBranch?.[0]?.IsDeliveryBranchCopy === 1) {
                            newArr1.push(bkngPrintOpt[1])
                        }
                        if (selectedBranch?.[0]?.IsDeliveryDriverCopy === 1) {
                            newArr1.push(bkngPrintOpt[2])
                        }
                    }

                    if (selectedBranch?.[0]?.CargoStandardTicketFormatID === 1 ||selectedBranch?.[0]?.CargoStandardTicketFormatID === 7) {
                        setBkngPrnitCopy(newArr)
                    } else if (selectedBranch?.[0]?.CargoStandardTicketFormatID === 4) {
                        setBkngPrnitCopy(bkngPrintOpt)
                    } else if (selectedBranch?.[0]?.CargoStandardTicketFormatID === 2) {
                        setBkngPrnitCopy([])
                    } else if (selectedBranch?.[0]?.CargoStandardTicketFormatID === 3) {
                        let filterData = bkngPrintOpt?.filter((item) => item?.id !== 3)
                        setBkngPrnitCopy(filterData)
                    } else if (selectedBranch?.[0]?.CargoStandardTicketFormatID === 5) {
                        setBkngPrnitCopy([])
                    }
                    if (selectedBranch?.[0]?.DeliveryPrintFormatID === 1) {
                        setDelPrnitCopy(newArr1)
                    } else if (selectedBranch?.[0]?.DeliveryPrintFormatID === 4) {
                        setDelPrnitCopy(bkngPrintOpt)
                    } else if (selectedBranch?.[0]?.DeliveryPrintFormatID === 2) {
                        setDelPrnitCopy([])
                    } else if (selectedBranch?.[0]?.DeliveryPrintFormatID === 3) {
                        let filterData = bkngPrintOpt?.filter((item) => item?.id !== 3)
                        setDelPrnitCopy(filterData)
                    } else if (selectedBranch?.[0]?.DeliveryPrintFormatID === 5) {
                        setDelPrnitCopy([])
                    }
                    if (selectedBranch?.[0]?.AccountingBranchID !== 0) {
                        let defBranch = BranchListOpt?.filter((obj) => obj.BranchID === selectedBranch?.[0]?.AccountingBranchID)
                        setBrnchOtherCargoValue({
                            ...selectedBranch?.[0],
                            "CreditLimit": selectedBranch?.[0]?.CargoCreditLimit > 0 ? CreditLimitTypeOpt[0] : CreditLimitTypeOpt[1],
                            "ChargeType": selectedBranch?.[0]?.LRPenaltyOnFreightAmt > 0 ? AmtAndPerOpt[1] : AmtAndPerOpt[0],
                            "RateType": selectedBranch?.[0]?.IsDefaultRateIncreasedBy === 1 ? selectedBranch?.[0]?.DefaultRateIncreaseAmt > 0 ? AmtAndPerOpt[1] : AmtAndPerOpt[0] : '',
                            'cargoAccBrnh': defBranch?.[0] || '',
                            'CreditLimitPayType': selectedBranch?.[0]?.CreditLimitPayType > 0 ? selectedBranch?.[0]?.CreditLimitPayType == 1 ? bookingTypeOpt[0] : bookingTypeOpt[1] : '',
                        })

                    } else {
                        setBrnchOtherCargoValue({
                            ...selectedBranch?.[0],
                            "CreditLimit": selectedBranch?.[0]?.CargoCreditLimit > 0 ? CreditLimitTypeOpt[0] : CreditLimitTypeOpt[1],
                            "ChargeType": selectedBranch?.[0]?.LRPenaltyOnFreightAmt > 0 ? AmtAndPerOpt[1] : AmtAndPerOpt[0],
                            "RateType": selectedBranch?.[0]?.IsDefaultRateIncreasedBy === 1 ? selectedBranch?.[0]?.DefaultRateIncreaseAmt > 0 ? AmtAndPerOpt[1] : AmtAndPerOpt[0] : '',
                            'cargoAccBrnh': '',
                            'CreditLimitPayType': selectedBranch?.[0]?.CreditLimitPayType > 0 ? selectedBranch?.[0]?.CreditLimitPayType == 1 ? bookingTypeOpt[0] : bookingTypeOpt[1] : ''
                        })
                    }
                    setShowBottom(true)
                }
                setIsDisableBtn((prev) => ({
                    ...prev,
                    branchOtherConfig: true
                }))

            } else {
                setShowBottom(false)
                setSuccessAndError({
                    isOpen: true,
                    id: 0,
                    title: res?.ErrMessage,
                    focusId: 'goBtn',
                    openNextTab: false
                })
                setBrnchOtherCargoValue(BrnchOtherCargoConfigObject)
                setIsDisableBtn((prev) => ({
                    ...prev,
                    branchOtherConfig: false
                }))
            }
        })

    }
    const getPdfData = async () => {
        let body = {
            intUserID: 0,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: 0,
            strBranchName: "",
            strBranchCode: "",
            intStateID: ModalHeaderDropDownData?.selState?.StateID,
            intCityID: ModalHeaderDropDownData?.selCity?.CityID,
            intIsActive: -1
        }
        try {
            const res = await getBranchDetailsInfo(body);
            if (res.status === "Success") {
                let newData = res?.Data?.Table
                newData = newData?.map((item) => ({
                    ...item,
                    ChargeType: item?.LRPenaltyOnFreightAmt > 0 ? AmtAndPerOpt[1] : AmtAndPerOpt[0],
                }))
                return newData
            } else {
                return [];
            }
        } catch (error) {
            return []; // Return an empty array in case of an error
        }
    }
    const handleBack = () => {
        updateModal(false, mdt.createNewBranchMaster)
    }
    const sendOTPRequest = () => {
        const obj = {
            StrEventType: 'Branch Edit',
            intCompanyID: loginData?.intCompanyID,
            intUserID: loginData?.intUserID,
            strContactNo: '',
            intBookingID: 0,
            intMode: 4,
            strBookingIDs: 0,
            intOTPToUserID: 0
        }
        luggageSendOTP(obj).then((res) => {
            if (res?.Status == true) {
                setOTP(res.OTP)
                setOtpModal(true)
            } else {
                if (res?.Status == false && res.ErrMessage === "Error:Policy & Number not updated") {
                    saveBrnchCargoConfig()
                } else {
                    setOTP("")
                    updateAlertError({ show: true, msg: res.ErrMessage })
                }
            }
        }).catch((err) => {
            updateAlertError({ show: true, msg: err })
            console.log("Error:", err)
        })
    }
    const onSave = () => {
        if (brnhOtherCargoGST?.errorModal) {
            setSuccessAndError({
                isOpen: true,
                id: 0,
                title: 'Enter Valid GST Number',
                focusId: 'cargo_book_gst',
                openNextTab: false
            })
        } else {
            sendOTPRequest()
        }

    }
    const tabInfo = {
        resetFlag,
        setResetFlag,
        resetAllValueBrnhMaster,
        getBranchCargoData,
        brnhOtherCargoValue,
        setBrnchOtherCargoValue,
        brnhOtherCargoGST,
        setBrnhOtherCargoGST,
        handleBack,
        showBottom,
        setShowBottom,
        onSave,
        headerData,
        getPdfData,
        loginData,
        confModal,
        setConfModal,
        isDisableBtn,
        setIsDisableBtn,
    }
    const contentShow = (key) => {
        let MasterTab
        switch (key) {
            case 11: {
                MasterTab = <OtherConfigCargo
                    tabInfo={tabInfo}
                    selOtherCargoAccBrnhOpt={selOtherCargoAccBrnhOpt}
                    showGstStatusModal={showGstStatusModal}
                />
                break
            }
            case 21: {
                MasterTab = <OtherCargoCreditLimit
                    tabInfo={tabInfo}
                />
                break
            }
            case 31: {
                MasterTab = <CancelLRPenaltyOnFreight
                    tabInfo={tabInfo}
                />
                break
            }
            case 50: {
                MasterTab = <OtherConfigCommission
                    tabInfo={tabInfo}
                />
                break
            }
            case 51: {
                MasterTab = <MinFreightPerParcel
                    tabInfo={tabInfo}
                />
                break
            } case 61: {
                MasterTab = <OtherConfigGST
                    tabInfo={tabInfo}
                />
                break
            } case 71: {
                MasterTab = <DefaultRateIncrease
                    tabInfo={tabInfo}
                />
                break
            }
            case 81: {
                MasterTab = <OtherConfigPrint
                    tabInfo={tabInfo}
                    waybillFormats={waybillFormats}
                    selectedOtherWayBill={selectedOtherWayBill} setSelectedOtherWayBillFormat={setSelectedOtherWayBillFormat}
                    selectedDeliveryWayBill={selectedDeliveryWayBill} setSelectedDeliveryWaybill={setSelectedDeliveryWaybill}
                    bkngPrnitCopy={bkngPrnitCopy} setBkngPrnitCopy={setBkngPrnitCopy}
                    delPrnitCopy={delPrnitCopy} setDelPrnitCopy={setDelPrnitCopy}
                />
                break
            }
            case 90: {
                MasterTab = <BookingDeliveryOTP tabInfo={tabInfo}/>
                break
            }

            //     default:
            //         MasterTab = ''
            //         break
        }
        return MasterTab
    }
    return (
        <>
            <Box className='brnchUsrMaster'>
                {
                    tabsList?.map((val, i) =>
                        <Button key={i} className={`brnchUsrMasterBtn ${masterNumber == val.JobID ? 'active' : ''}`} variant="outlined" onClick={() => goToTabs(val.JobID)}
                            sx={{
                                display: 'inline-block'
                                // val.JobID !== 4 ? findObjctByValueFromArrayOfObject(allTabs, val.JobID, 'JobID', "IsActive") === 1
                                //     ? 'inline-block'
                                //     : 'none' : 'inline-block',
                            }}
                        >{val.name}</Button>
                    )
                }
            </Box>
            <Box>
                {contentShow(masterNumber)}
            </Box>
            {gstStatusModal && <GSTStatusModal  {...gstStatusModalProps} />}
            <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => {
                if (successAndError?.openNextTab && successAndError?.id === 1) {
                    setSelectedTab(tabData?.isnextValue)
                    setConfModal((prev) => ({
                        ...prev,
                        branchOtherConfig: false
                    }))
                }
                setSuccessAndError({
                    isOpen: false,
                    id: 0,
                    title: '',
                    openNextTab: false
                })
                setIsOpen({ ...isOpen, open: false, message: "" })
                setOTP('')
                setOtpModal(false)
                focusElemnt(successAndError?.focusId)
                setShowBottom(true)
            }} isError={successAndError?.id === 0} open={successAndError?.isOpen} title={successAndError?.title} />
            {OtpModal ? <OTPModal saveApi={saveBrnchCargoConfig} OTP={OTP} isOpen={isOpen} setIsOpen={setIsOpen} sendOTPRequest={sendOTPRequest} /> : ""}
            {confModal?.branchOtherConfig && tabData?.isChgTab && <ConfirmModal title="Branch Cargo Other Config" header="Do You Want to update the Branch Other Cargo" updateModal={() => {
                setSelectedTab(tabData?.isnextValue)
                setConfModal((prev) => ({
                    ...prev,
                    branchOtherConfig: false
                }))
                setTabData((prev) => ({
                    ...prev,
                    isChgTab: false,
                }))
            }}
                handleConfirm={() => {
                    onSave()
                    // saveBrnchCargoConfig(true)
                    setTabData((prev) => ({
                        ...prev,
                        isChgTab: false,
                    }))
                }}

            />
            }
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getBranchData, getPrintFormatList, updateAlertError, getBranchMaster, updateOtherCargoBranchCofigData, getGSTNValidation, getBranchDetailsInfo }
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(BranchCargoOtherConfig))
